import builder from '../builder';
import CashPaymentCoin from '../../streamline-icons/bold/cash-payment-coin.svg';

export default builder('IconCashPaymentCoinBold', CashPaymentCoin);
